module.exports = __webpack_public_path__ + "img/2.862f34e1.jpg";